import type { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

export const query = graphql(`
    query AppFlipperQuery($id: ID!, $submitType: FlipperSubmitType!) {
        flipper(id: $id, submitType: $submitType) {
            lockedTasks {
                id
                icon
                name
            }
            animations
            finishMessage
            icon
            milesEarned
            pipId
            pathId
            milesCheckpoint
            milesGoal
            showMilesText
            passedCheckpoint
            passedGoal
            redirectUrl
        }
    }
`);

export type AnimationType = "task" | "unlock" | "milestone" | "redirect";

export type IFlipper = ResultOf<typeof query>["flipper"];
